import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { PROGRAM_SELECTIONS_ITEMS } from '../constants/state'


const mapStateToProps = (state, ownProps) => ({
    selection: getData(state, [PROGRAM_SELECTIONS_ITEMS, ownProps.selectionId])
})


const SelectionsDisplayNavItemAccess = ({
    htmlId,
    selection
}) => {
    if(!selection.collections || !selection.collections.length > 0) {
        return ''
    } else {
        return (
            <li>
                <a href={`#${htmlId}`} className="text-medium access-typo">{selection.title ? selection.title : 'Skip to Section'}</a>
            </li>
        )
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(SelectionsDisplayNavItemAccess)